import { ERC721Metadata } from "./erc721";
export class ERC1155Metadata extends ERC721Metadata {
    constructor(params) {
        super(params);
    }
}
